import { Link } from "react-router-dom";
const Missing = () => {
  return (
    <article className="min-h-screen px-6 py-24 bg-linear-to-br from-emerald-100 via-green-100 to-emerald-200 text-emerald-900 flex flex-col items-center justify-center text-center">
      <h1 className="mb-4 text-5xl font-semibold tracking-[0.4rem] uppercase text-emerald-700">
        Oops!
      </h1>
      <p className="mb-8 max-w-md text-lg leading-relaxed text-emerald-800/90">
        We couldn't find the page you're looking for. It might have been moved
        or deleted, but you can always head back home.
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center rounded-full bg-emerald-500 px-7 py-3 font-semibold text-white shadow-lg transition duration-200 hover:-translate-y-0.5 hover:bg-emerald-600 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400"
      >
        Back to Home
      </Link>
    </article>
  );
};

export default Missing;
